export default "__VITE_ASSET__C$w4yj_H__"